import React from 'react';
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import {useAppSelector} from "../../hooks/redux";
import {getLanguage} from "../../store/selectors/appSelector";
import {UIText} from "../../enums/UIText/UIText";
import {EnumPages} from "../../enums/EnumPages";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";

const Education = () => {

    const language = useAppSelector(getLanguage)

    return (
        <LayoutContentWrapper>
            <ContentHeader title={getTextByLanguage(UIText.nav.educationalProgram, language)}
                           description={'Description...'}
                           pageName={EnumPages.education}
                           editable={true}
            />
            Education page, test deploy
        </LayoutContentWrapper>
    );
};

export default Education;